import common from './common';
import templates from './templates';
import selectors from './selectors';

export default {
  common,
  templates,
  selectors,
};
